export const LiftStationWidget = () => (
  <svg
    width="164"
    height="107"
    viewBox="0 0 164 107"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask id="path-1-inside-1_22398_11359" fill="white">
      <path d="M0.960938 52.8593H163.039V102.836C163.039 104.605 161.605 106.039 159.836 106.039H3.84375C2.25162 106.039 0.960938 104.748 0.960938 103.156V52.8593Z" />
    </mask>
    <path
      d="M0.960938 52.8593H163.039V102.836C163.039 104.605 161.605 106.039 159.836 106.039H3.84375C2.25162 106.039 0.960938 104.748 0.960938 103.156V52.8593Z"
      fill="#2486FD"
      fillOpacity="0.2"
    />
    <path
      d="M0.960938 52.2186H163.039V53.4999H0.960938V52.2186ZM163.039 106.039H0.960938H163.039ZM0.960938 106.039V52.8593V106.039ZM163.039 52.8593V106.039V52.8593Z"
      fill="#2486FD"
      mask="url(#path-1-inside-1_22398_11359)"
    />
    <rect
      x="0.240234"
      y="0.240234"
      width="163.52"
      height="106.52"
      rx="3.60352"
      stroke="#C9CDCF"
      strokeWidth="0.480469"
    />
    <path
      d="M70.0823 15.3133C71.7388 15.3133 73.0816 13.9705 73.0816 12.314C73.0816 10.6575 71.7388 9.3147 70.0823 9.3147C68.4258 9.3147 67.083 10.6575 67.083 12.314C67.083 13.9705 68.4258 15.3133 70.0823 15.3133Z"
      fill="#C9CDCF"
      stroke="#231F20"
      strokeWidth="0.22492"
      strokeMiterlimit="10"
    />
    <path
      d="M69.9282 14.4805H65.342C65.2558 14.4805 65.1732 14.5148 65.1122 14.5757C65.0513 14.6367 65.017 14.7194 65.017 14.8056V66.7293L60.7852 66.7405V14.4636V11.9363C60.7852 11.7147 60.8288 11.4953 60.9136 11.2907C60.9983 11.086 61.1226 10.9 61.2792 10.7433C61.4359 10.5866 61.6218 10.4624 61.8265 10.3776C62.0312 10.2928 62.2505 10.2491 62.4721 10.2491H69.9282C70.4891 10.2491 71.0271 10.4719 71.424 10.8683C71.8208 11.2648 72.0441 11.8027 72.0447 12.3637C72.0447 12.9251 71.8217 13.4635 71.4248 13.8605C71.0278 14.2575 70.4895 14.4805 69.9282 14.4805Z"
      fill="#F4F4F7"
      stroke="#231F20"
      strokeWidth="0.22492"
      strokeMiterlimit="10"
    />
    <path
      d="M61.8114 12.9733C61.7369 12.9733 61.6653 12.9437 61.6126 12.8909C61.5599 12.8382 61.5303 12.7667 61.5303 12.6921V12.0635C61.5301 11.9231 61.5577 11.7842 61.6113 11.6545C61.6649 11.5248 61.7436 11.4069 61.8429 11.3077C61.9421 11.2085 62.0599 11.1298 62.1896 11.0761C62.3193 11.0225 62.4583 10.995 62.5986 10.9951H63.1992C63.2737 10.9951 63.3453 11.0247 63.398 11.0775C63.4507 11.1302 63.4803 11.2017 63.4803 11.2763C63.4803 11.3508 63.4507 11.4223 63.398 11.4751C63.3453 11.5278 63.2737 11.5574 63.1992 11.5574H62.5986C62.5321 11.5573 62.4663 11.5703 62.4048 11.5956C62.3433 11.621 62.2875 11.6583 62.2405 11.7053C62.1934 11.7523 62.1562 11.8082 62.1308 11.8696C62.1054 11.9311 62.0924 11.997 62.0926 12.0635V12.6888C62.0923 12.7632 62.0626 12.8346 62.0099 12.8872C61.9572 12.9399 61.8859 12.9696 61.8114 12.9699V12.9733Z"
      fill="white"
    />
    <path
      d="M63.2003 11.1072C63.2451 11.1072 63.288 11.125 63.3196 11.1567C63.3512 11.1883 63.369 11.2312 63.369 11.2759C63.369 11.3207 63.3512 11.3636 63.3196 11.3952C63.288 11.4269 63.2451 11.4446 63.2003 11.4446H62.5998C62.4357 11.4446 62.2784 11.5098 62.1624 11.6258C62.0464 11.7418 61.9812 11.8991 61.9812 12.0632V12.6884C61.9812 12.7332 61.9635 12.7761 61.9318 12.8077C61.9002 12.8394 61.8573 12.8571 61.8126 12.8571C61.7678 12.8571 61.7249 12.8394 61.6933 12.8077C61.6616 12.7761 61.6439 12.7332 61.6439 12.6884V12.0632C61.6436 11.9375 61.6681 11.8131 61.716 11.697C61.764 11.5809 61.8344 11.4754 61.9232 11.3866C62.012 11.2977 62.1175 11.2273 62.2336 11.1794C62.3497 11.1315 62.4742 11.1069 62.5998 11.1072H63.2003ZM63.2003 10.8823H62.5998C62.4446 10.8823 62.291 10.9129 62.1476 10.9723C62.0043 11.0317 61.8741 11.1188 61.7644 11.2286C61.6547 11.3383 61.5678 11.4687 61.5085 11.6121C61.4492 11.7554 61.4188 11.9091 61.4189 12.0643V12.6884C61.4189 12.7928 61.4604 12.8929 61.5342 12.9668C61.608 13.0406 61.7082 13.082 61.8126 13.082C61.9169 13.082 62.0171 13.0406 62.0909 12.9668C62.1647 12.8929 62.2062 12.7928 62.2062 12.6884V12.0632C62.2059 12.0114 62.2158 11.9601 62.2355 11.9122C62.2552 11.8643 62.2842 11.8208 62.3208 11.7842C62.3574 11.7476 62.4009 11.7186 62.4488 11.6989C62.4967 11.6792 62.548 11.6692 62.5998 11.6695H63.2003C63.3047 11.6695 63.4048 11.6281 63.4786 11.5543C63.5525 11.4804 63.5939 11.3803 63.5939 11.2759C63.5939 11.1715 63.5525 11.0714 63.4786 10.9976C63.4048 10.9238 63.3047 10.8823 63.2003 10.8823Z"
      fill="#C9CDCF"
    />
    <path
      d="M72.0558 92.0975C72.0534 92.9055 71.7314 93.6797 71.1602 94.251C70.589 94.8224 69.8149 95.1444 69.007 95.1468H56.8613C56.0527 95.1468 55.2772 94.8255 54.7055 94.2537C54.1337 93.6818 53.8125 92.9062 53.8125 92.0975C53.8125 91.2888 54.1337 90.5132 54.7055 89.9414C55.2772 89.3695 56.0527 89.0483 56.8613 89.0483H57.2358V84.899H56.8489C56.3683 84.8975 55.9078 84.7059 55.5679 84.366C55.228 84.0261 55.0364 83.5655 55.0349 83.0848V82.8137C55.0364 82.3331 55.2281 81.8726 55.568 81.5329C55.9079 81.1931 56.3684 81.0018 56.8489 81.0006H57.2335V67.8779C57.2335 67.5796 57.352 67.2935 57.5629 67.0826C57.7738 66.8717 58.0599 66.7532 58.3581 66.7532H67.5057C67.8039 66.7532 68.09 66.8717 68.3009 67.0826C68.5118 67.2935 68.6303 67.5796 68.6303 67.8779V81.0006H69.0149C69.4954 81.0018 69.9559 81.1931 70.2958 81.5329C70.6357 81.8726 70.8274 82.3331 70.8289 82.8137V83.0848C70.8274 83.5651 70.6361 84.0254 70.2967 84.3652C69.9573 84.7051 69.4974 84.8969 69.0171 84.899H68.6325V89.0483H69.007C69.8149 89.0504 70.5892 89.3723 71.1605 89.9437C71.7318 90.5151 72.0537 91.2895 72.0558 92.0975Z"
      fill="#F4F4F7"
      stroke="#231F20"
      strokeWidth="0.22492"
      strokeMiterlimit="10"
    />
    <path
      d="M59.7021 69.1187V78.3676"
      stroke="#231F20"
      strokeWidth="0.22492"
      strokeMiterlimit="10"
    />
    <path
      d="M61.3184 69.1187V78.3676"
      stroke="#231F20"
      strokeWidth="0.22492"
      strokeMiterlimit="10"
    />
    <path
      d="M62.9346 69.1187V78.3676"
      stroke="#231F20"
      strokeWidth="0.22492"
      strokeMiterlimit="10"
    />
    <path
      d="M64.5498 69.1187V78.3676"
      stroke="#231F20"
      strokeWidth="0.22492"
      strokeMiterlimit="10"
    />
    <path
      d="M66.166 69.1187V78.3676"
      stroke="#231F20"
      strokeWidth="0.22492"
      strokeMiterlimit="10"
    />
    <path
      d="M66.8205 66.7526V64.0715C66.8187 63.716 66.6766 63.3754 66.4252 63.124C66.1738 62.8726 65.8333 62.7305 65.4777 62.7288H60.3236C59.9688 62.7317 59.6295 62.8743 59.379 63.1256C59.1285 63.3769 58.9871 63.7167 58.9854 64.0715V66.7526H60.11V64.0715C60.1116 64.0142 60.1352 63.9597 60.1757 63.9191C60.2163 63.8786 60.2708 63.8551 60.3281 63.8534H65.4822C65.5221 63.8543 65.5611 63.8658 65.5951 63.8867C65.629 63.9077 65.6568 63.9373 65.6756 63.9726V66.7526H66.8205Z"
      fill="#C9CDCF"
      stroke="#231F20"
      strokeWidth="0.22492"
      strokeMiterlimit="10"
    />
    <path
      d="M62.8972 90.7499C65.2767 90.7499 67.2056 88.8207 67.2056 86.4409C67.2056 84.0612 65.2767 82.132 62.8972 82.132C60.5178 82.132 58.5889 84.0612 58.5889 86.4409C58.5889 88.8207 60.5178 90.7499 62.8972 90.7499Z"
      fill="#05B6B2"
    />
    <path
      d="M62.9095 83.9851V80.049C62.9095 80.049 61.5296 80.5202 61.4767 82.2498C60.8235 82.4718 60.2312 82.8435 59.7471 83.335"
      fill="#05B6B2"
    />
    <path
      d="M62.9095 83.9851V80.049C62.9095 80.049 61.5296 80.5202 61.4767 82.2498C60.8235 82.4718 60.2312 82.8435 59.7471 83.335"
      stroke="#231F20"
      strokeWidth="0.22492"
      strokeMiterlimit="10"
    />
    <path d="M58.9062 84.5074L58.9165 84.5177Z" fill="#05B6B2" />
    <path
      d="M58.9062 84.5074L58.9165 84.5177"
      stroke="#231F20"
      strokeWidth="0.22492"
      strokeMiterlimit="10"
    />
    <path
      d="M61.1571 84.7321L58.3737 81.9487C58.3737 81.9487 57.7327 83.2555 58.9147 84.5162C58.6237 85.1159 58.473 85.7739 58.4738 86.4404C58.4738 86.4606 58.4738 86.4797 58.4738 86.4989"
      fill="#05B6B2"
    />
    <path
      d="M61.1571 84.7321L58.3737 81.9487C58.3737 81.9487 57.7327 83.2555 58.9147 84.5162C58.6237 85.1159 58.473 85.7739 58.4738 86.4404C58.4738 86.4606 58.4738 86.4797 58.4738 86.4989"
      stroke="#231F20"
      strokeWidth="0.22492"
      strokeMiterlimit="10"
    />
    <path
      d="M60.4478 86.4994H56.5117C56.5117 86.4994 56.9852 87.8905 58.7328 87.9355C58.9632 88.5775 59.3389 89.1575 59.8304 89.6303"
      fill="#05B6B2"
    />
    <path
      d="M60.4478 86.4994H56.5117C56.5117 86.4994 56.9852 87.8905 58.7328 87.9355C58.9632 88.5775 59.3389 89.1575 59.8304 89.6303"
      stroke="#231F20"
      strokeWidth="0.22492"
      strokeMiterlimit="10"
    />
    <path
      d="M61.1926 88.2531L58.4092 91.0353C58.4092 91.0353 59.7497 91.6932 61.0239 90.4494C61.6107 90.7221 62.2504 90.8623 62.8975 90.8599"
      fill="#05B6B2"
    />
    <path
      d="M61.1926 88.2531L58.4092 91.0353C58.4092 91.0353 59.7497 91.6932 61.0239 90.4494C61.6107 90.7221 62.2504 90.8623 62.8975 90.8599"
      stroke="#231F20"
      strokeWidth="0.22492"
      strokeMiterlimit="10"
    />
    <path
      d="M62.958 88.965V92.9011C62.958 92.9011 64.3863 92.413 64.3919 90.6069C65.0118 90.3838 65.5739 90.0249 66.0372 89.5565"
      fill="#05B6B2"
    />
    <path
      d="M62.958 88.965V92.9011C62.958 92.9011 64.3863 92.413 64.3919 90.6069C65.0118 90.3838 65.5739 90.0249 66.0372 89.5565"
      stroke="#231F20"
      strokeWidth="0.22492"
      strokeMiterlimit="10"
    />
    <path
      d="M64.7109 88.2178L67.4943 91.0001C67.4943 91.0001 68.1601 89.6427 66.8837 88.3606C67.1721 87.7618 67.3213 87.1055 67.32 86.4409"
      fill="#05B6B2"
    />
    <path
      d="M64.7109 88.2178L67.4943 91.0001C67.4943 91.0001 68.1601 89.6427 66.8837 88.3606C67.1721 87.7618 67.3213 87.1055 67.32 86.4409"
      stroke="#231F20"
      strokeWidth="0.22492"
      strokeMiterlimit="10"
    />
    <path
      d="M64.6768 84.6969L67.4602 81.9147C67.4602 81.9147 66.1354 81.2646 64.8736 82.477C64.2616 82.1724 63.587 82.0145 62.9033 82.0159"
      fill="#05B6B2"
    />
    <path
      d="M64.6768 84.6969L67.4602 81.9147C67.4602 81.9147 66.1354 81.2646 64.8736 82.477C64.2616 82.1724 63.587 82.0145 62.9033 82.0159"
      stroke="#231F20"
      strokeWidth="0.22492"
      strokeMiterlimit="10"
    />
    <path
      d="M62.8968 87.9118C63.7092 87.9118 64.3677 87.2532 64.3677 86.4408C64.3677 85.6284 63.7092 84.9698 62.8968 84.9698C62.0844 84.9698 61.4258 85.6284 61.4258 86.4408C61.4258 87.2532 62.0844 87.9118 62.8968 87.9118Z"
      fill="#05B6B2"
      stroke="#231F20"
      strokeWidth="0.22492"
      strokeMiterlimit="10"
    />
    <path
      d="M66.024 83.3142C66.5016 83.7917 66.8636 84.3722 67.0822 85.0112C68.8703 85.0281 69.3551 86.4462 69.3551 86.4462H65.4189"
      fill="#05B6B2"
    />
    <path
      d="M66.024 83.3142C66.5016 83.7917 66.8636 84.3722 67.0822 85.0112C68.8703 85.0281 69.3551 86.4462 69.3551 86.4462H65.4189"
      stroke="#231F20"
      strokeWidth="0.22492"
      strokeMiterlimit="10"
    />
    <path
      d="M103.395 15.3133C105.051 15.3133 106.394 13.9705 106.394 12.314C106.394 10.6575 105.051 9.3147 103.395 9.3147C101.738 9.3147 100.396 10.6575 100.396 12.314C100.396 13.9705 101.738 15.3133 103.395 15.3133Z"
      fill="#C9CDCF"
      stroke="#231F20"
      strokeWidth="0.22492"
      strokeMiterlimit="10"
    />
    <path
      d="M103.241 14.4805H98.6545C98.5683 14.4805 98.4857 14.5148 98.4247 14.5757C98.3638 14.6367 98.3295 14.7194 98.3295 14.8056V66.7293L94.0977 66.7405V14.4636V11.9363C94.0977 11.7147 94.1413 11.4953 94.2261 11.2907C94.3108 11.086 94.4351 10.9 94.5917 10.7433C94.7484 10.5866 94.9343 10.4624 95.139 10.3776C95.3437 10.2928 95.563 10.2491 95.7846 10.2491H103.241C103.802 10.2491 104.34 10.4719 104.736 10.8683C105.133 11.2648 105.357 11.8027 105.357 12.3637C105.357 12.9251 105.134 13.4635 104.737 13.8605C104.34 14.2575 103.802 14.4805 103.241 14.4805Z"
      fill="#F4F4F7"
      stroke="#231F20"
      strokeWidth="0.22492"
      strokeMiterlimit="10"
    />
    <path
      d="M95.1239 12.9733C95.0494 12.9733 94.9778 12.9437 94.9251 12.8909C94.8724 12.8382 94.8428 12.7667 94.8428 12.6921V12.0635C94.8426 11.9231 94.8702 11.7842 94.9238 11.6545C94.9774 11.5248 95.0561 11.4069 95.1554 11.3077C95.2546 11.2085 95.3724 11.1298 95.5021 11.0761C95.6318 11.0225 95.7708 10.995 95.9111 10.9951H96.5117C96.5862 10.9951 96.6578 11.0247 96.7105 11.0775C96.7632 11.1302 96.7928 11.2017 96.7928 11.2763C96.7928 11.3508 96.7632 11.4223 96.7105 11.4751C96.6578 11.5278 96.5862 11.5574 96.5117 11.5574H95.9111C95.8446 11.5573 95.7788 11.5703 95.7173 11.5956C95.6558 11.621 95.6 11.6583 95.553 11.7053C95.5059 11.7523 95.4687 11.8082 95.4433 11.8696C95.4179 11.9311 95.4049 11.997 95.4051 12.0635V12.6888C95.4048 12.7632 95.3751 12.8346 95.3224 12.8872C95.2697 12.9399 95.1984 12.9696 95.1239 12.9699V12.9733Z"
      fill="white"
    />
    <path
      d="M96.5118 11.1075C96.5566 11.1075 96.5995 11.1253 96.6311 11.1569C96.6628 11.1885 96.6805 11.2314 96.6805 11.2762C96.6805 11.3209 96.6628 11.3638 96.6311 11.3955C96.5995 11.4271 96.5566 11.4449 96.5118 11.4449H95.9113C95.7473 11.4449 95.5899 11.51 95.4739 11.626C95.3579 11.742 95.2928 11.8994 95.2928 12.0634V12.6887C95.2928 12.7334 95.275 12.7763 95.2434 12.808C95.2117 12.8396 95.1688 12.8574 95.1241 12.8574C95.0793 12.8574 95.0364 12.8396 95.0048 12.808C94.9732 12.7763 94.9554 12.7334 94.9554 12.6887V12.0634C94.9551 11.9378 94.9796 11.8133 95.0276 11.6972C95.0755 11.5811 95.1459 11.4756 95.2347 11.3868C95.3235 11.298 95.429 11.2276 95.5451 11.1796C95.6612 11.1317 95.7857 11.1072 95.9113 11.1075H96.5118ZM96.5118 10.8826H95.9113C95.7561 10.8826 95.6025 10.9131 95.4592 10.9726C95.3158 11.032 95.1856 11.1191 95.0759 11.2288C94.9663 11.3386 94.8793 11.4689 94.82 11.6123C94.7608 11.7557 94.7303 11.9094 94.7305 12.0645V12.6887C94.7305 12.7931 94.7719 12.8932 94.8458 12.967C94.9196 13.0408 95.0197 13.0823 95.1241 13.0823C95.2285 13.0823 95.3286 13.0408 95.4024 12.967C95.4762 12.8932 95.5177 12.7931 95.5177 12.6887V12.0634C95.5174 12.0116 95.5274 11.9603 95.547 11.9124C95.5667 11.8645 95.5957 11.821 95.6323 11.7844C95.6689 11.7478 95.7124 11.7188 95.7603 11.6991C95.8082 11.6795 95.8595 11.6695 95.9113 11.6698H96.5118C96.6162 11.6698 96.7163 11.6283 96.7902 11.5545C96.864 11.4807 96.9054 11.3806 96.9054 11.2762C96.9054 11.1718 96.864 11.0717 96.7902 10.9979C96.7163 10.924 96.6162 10.8826 96.5118 10.8826Z"
      fill="#C9CDCF"
    />
    <path
      d="M105.368 92.0975C105.366 92.9055 105.044 93.6797 104.473 94.251C103.901 94.8224 103.127 95.1444 102.319 95.1468H90.1738C89.3652 95.1468 88.5897 94.8255 88.018 94.2537C87.4462 93.6818 87.125 92.9062 87.125 92.0975C87.125 91.2888 87.4462 90.5132 88.018 89.9414C88.5897 89.3695 89.3652 89.0483 90.1738 89.0483H90.5483V84.899H90.1614C89.6808 84.8975 89.2203 84.7059 88.8804 84.366C88.5405 84.0261 88.3489 83.5655 88.3474 83.0848V82.8137C88.3489 82.3331 88.5406 81.8726 88.8805 81.5329C89.2204 81.1931 89.6809 81.0018 90.1614 81.0006H90.546V67.8779C90.546 67.5796 90.6645 67.2935 90.8754 67.0826C91.0863 66.8717 91.3724 66.7532 91.6706 66.7532H100.818C101.116 66.7532 101.402 66.8717 101.613 67.0826C101.824 67.2935 101.943 67.5796 101.943 67.8779V81.0006H102.327C102.808 81.0018 103.268 81.1931 103.608 81.5329C103.948 81.8726 104.14 82.3331 104.141 82.8137V83.0848C104.14 83.5651 103.949 84.0254 103.609 84.3652C103.27 84.7051 102.81 84.8969 102.33 84.899H101.945V89.0483H102.319C103.127 89.0504 103.902 89.3723 104.473 89.9437C105.044 90.5151 105.366 91.2895 105.368 92.0975Z"
      fill="#F4F4F7"
      stroke="#231F20"
      strokeWidth="0.22492"
      strokeMiterlimit="10"
    />
    <path
      d="M93.0146 69.1187V78.3676"
      stroke="#231F20"
      strokeWidth="0.22492"
      strokeMiterlimit="10"
    />
    <path
      d="M94.6299 69.1187V78.3676"
      stroke="#231F20"
      strokeWidth="0.22492"
      strokeMiterlimit="10"
    />
    <path
      d="M96.2461 69.1187V78.3676"
      stroke="#231F20"
      strokeWidth="0.22492"
      strokeMiterlimit="10"
    />
    <path
      d="M97.8633 69.1187V78.3676"
      stroke="#231F20"
      strokeWidth="0.22492"
      strokeMiterlimit="10"
    />
    <path
      d="M99.4795 69.1187V78.3676"
      stroke="#231F20"
      strokeWidth="0.22492"
      strokeMiterlimit="10"
    />
    <path
      d="M100.133 66.7526V64.0715C100.131 63.716 99.9891 63.3754 99.7377 63.124C99.4863 62.8726 99.1458 62.7305 98.7902 62.7288H93.6361C93.2813 62.7317 92.942 62.8743 92.6915 63.1256C92.441 63.3769 92.2996 63.7167 92.2979 64.0715V66.7526H93.4225V64.0715C93.4241 64.0142 93.4477 63.9597 93.4882 63.9191C93.5288 63.8786 93.5833 63.8551 93.6406 63.8534H98.7947C98.8346 63.8543 98.8736 63.8658 98.9076 63.8867C98.9415 63.9077 98.9693 63.9373 98.9881 63.9726V66.7526H100.133Z"
      fill="#C9CDCF"
      stroke="#231F20"
      strokeWidth="0.22492"
      strokeMiterlimit="10"
    />
    <path
      d="M96.2097 90.7499C98.5892 90.7499 100.518 88.8207 100.518 86.4409C100.518 84.0612 98.5892 82.132 96.2097 82.132C93.8303 82.132 91.9014 84.0612 91.9014 86.4409C91.9014 88.8207 93.8303 90.7499 96.2097 90.7499Z"
      fill="#05B6B2"
    />
    <path
      d="M96.222 83.9851V80.049C96.222 80.049 94.8421 80.5202 94.7892 82.2498C94.136 82.4718 93.5437 82.8435 93.0596 83.335"
      fill="#05B6B2"
    />
    <path
      d="M96.222 83.9851V80.049C96.222 80.049 94.8421 80.5202 94.7892 82.2498C94.136 82.4718 93.5437 82.8435 93.0596 83.335"
      stroke="#231F20"
      strokeWidth="0.22492"
      strokeMiterlimit="10"
    />
    <path d="M92.2188 84.5074L92.229 84.5177Z" fill="#05B6B2" />
    <path
      d="M92.2188 84.5074L92.229 84.5177"
      stroke="#231F20"
      strokeWidth="0.22492"
      strokeMiterlimit="10"
    />
    <path
      d="M94.4696 84.7321L91.6862 81.9487C91.6862 81.9487 91.0452 83.2555 92.2272 84.5162C91.9362 85.1159 91.7855 85.7739 91.7863 86.4404C91.7863 86.4606 91.7863 86.4797 91.7863 86.4989"
      fill="#05B6B2"
    />
    <path
      d="M94.4696 84.7321L91.6862 81.9487C91.6862 81.9487 91.0452 83.2555 92.2272 84.5162C91.9362 85.1159 91.7855 85.7739 91.7863 86.4404C91.7863 86.4606 91.7863 86.4797 91.7863 86.4989"
      stroke="#231F20"
      strokeWidth="0.22492"
      strokeMiterlimit="10"
    />
    <path
      d="M93.7603 86.4994H89.8242C89.8242 86.4994 90.2977 87.8905 92.0453 87.9355C92.2757 88.5775 92.6514 89.1575 93.1429 89.6303"
      fill="#05B6B2"
    />
    <path
      d="M93.7603 86.4994H89.8242C89.8242 86.4994 90.2977 87.8905 92.0453 87.9355C92.2757 88.5775 92.6514 89.1575 93.1429 89.6303"
      stroke="#231F20"
      strokeWidth="0.22492"
      strokeMiterlimit="10"
    />
    <path
      d="M94.5051 88.2531L91.7217 91.0353C91.7217 91.0353 93.0622 91.6932 94.3364 90.4494C94.9232 90.7221 95.5629 90.8623 96.21 90.8599"
      fill="#05B6B2"
    />
    <path
      d="M94.5051 88.2531L91.7217 91.0353C91.7217 91.0353 93.0622 91.6932 94.3364 90.4494C94.9232 90.7221 95.5629 90.8623 96.21 90.8599"
      stroke="#231F20"
      strokeWidth="0.22492"
      strokeMiterlimit="10"
    />
    <path
      d="M96.2715 88.965V92.9011C96.2715 92.9011 97.6997 92.413 97.7054 90.6069C98.3252 90.3838 98.8874 90.0249 99.3506 89.5565"
      fill="#05B6B2"
    />
    <path
      d="M96.2715 88.965V92.9011C96.2715 92.9011 97.6997 92.413 97.7054 90.6069C98.3252 90.3838 98.8874 90.0249 99.3506 89.5565"
      stroke="#231F20"
      strokeWidth="0.22492"
      strokeMiterlimit="10"
    />
    <path
      d="M98.0234 88.2178L100.807 91.0001C100.807 91.0001 101.473 89.6427 100.196 88.3606C100.485 87.7618 100.634 87.1055 100.633 86.4409"
      fill="#05B6B2"
    />
    <path
      d="M98.0234 88.2178L100.807 91.0001C100.807 91.0001 101.473 89.6427 100.196 88.3606C100.485 87.7618 100.634 87.1055 100.633 86.4409"
      stroke="#231F20"
      strokeWidth="0.22492"
      strokeMiterlimit="10"
    />
    <path
      d="M97.9883 84.6969L100.772 81.9147C100.772 81.9147 99.4469 81.2646 98.1851 82.477C97.5731 82.1724 96.8985 82.0145 96.2148 82.0159"
      fill="#05B6B2"
    />
    <path
      d="M97.9883 84.6969L100.772 81.9147C100.772 81.9147 99.4469 81.2646 98.1851 82.477C97.5731 82.1724 96.8985 82.0145 96.2148 82.0159"
      stroke="#231F20"
      strokeWidth="0.22492"
      strokeMiterlimit="10"
    />
    <path
      d="M96.2093 87.9118C97.0217 87.9118 97.6802 87.2532 97.6802 86.4408C97.6802 85.6284 97.0217 84.9698 96.2093 84.9698C95.3969 84.9698 94.7383 85.6284 94.7383 86.4408C94.7383 87.2532 95.3969 87.9118 96.2093 87.9118Z"
      fill="#05B6B2"
      stroke="#231F20"
      strokeWidth="0.22492"
      strokeMiterlimit="10"
    />
    <path
      d="M99.3375 83.3142C99.8151 83.7917 100.177 84.3722 100.396 85.0112C102.184 85.0281 102.669 86.4462 102.669 86.4462H98.7324"
      fill="#05B6B2"
    />
    <path
      d="M99.3375 83.3142C99.8151 83.7917 100.177 84.3722 100.396 85.0112C102.184 85.0281 102.669 86.4462 102.669 86.4462H98.7324"
      stroke="#231F20"
      strokeWidth="0.22492"
      strokeMiterlimit="10"
    />
    <circle cx="5.82213" cy="95.4497" r="0.982285" fill="#657289" />
    <path
      d="M5.0918 95.3876H6.51074C7.05038 95.3877 7.51268 95.7736 7.60938 96.3046L8.46777 101.02C8.6035 101.767 8.24313 102.516 7.5752 102.877C6.64173 103.381 5.52025 103.394 4.5752 102.912L4.47168 102.859C3.77423 102.504 3.37052 101.752 3.45898 100.974L3.98145 96.3788C4.04565 95.8143 4.52369 95.3876 5.0918 95.3876Z"
      fill="#05B6B2"
      stroke="#657289"
      strokeWidth="0.203117"
    />
    <path
      d="M5.04866 102.515L4.96507 102.49C4.58176 102.377 4.27604 102.086 4.14269 101.709L4.08779 101.554"
      stroke="#F2F3F5"
      strokeWidth="0.203117"
    />
    <path
      d="M6.40659 95.7946L6.60858 95.8077C6.89874 95.8266 7.13514 96.0478 7.17316 96.3361L7.20734 96.5953"
      stroke="#F2F3F5"
      strokeWidth="0.203117"
    />
    <rect x="5.76562" y="0.640625" width="0.320312" height="94.1856" fill="#657289" />
    <circle cx="9.66588" cy="79.4317" r="0.982285" fill="#657289" />
    <path
      d="M8.93555 79.3696H10.3545C10.8941 79.3698 11.3564 79.7557 11.4531 80.2866L12.3115 85.0024C12.4473 85.7492 12.0869 86.4984 11.4189 86.8589C10.4855 87.3627 9.364 87.3758 8.41895 86.894L8.31543 86.8413C7.61798 86.4858 7.21427 85.7344 7.30273 84.9565L7.8252 80.3608C7.8894 79.7964 8.36744 79.3697 8.93555 79.3696Z"
      fill="#05B6B2"
      stroke="#657289"
      strokeWidth="0.203117"
    />
    <path
      d="M8.89241 86.4968L8.80882 86.472C8.42551 86.3583 8.11979 86.068 7.98644 85.691L7.93154 85.5358"
      stroke="#F2F3F5"
      strokeWidth="0.203117"
    />
    <path
      d="M10.2503 79.7766L10.4523 79.7898C10.7425 79.8086 10.9789 80.0299 11.0169 80.3182L11.0511 80.5774"
      stroke="#F2F3F5"
      strokeWidth="0.203117"
    />
    <rect x="9.60938" y="0.640625" width="0.320312" height="78.1677" fill="#657289" />
    <circle cx="13.5096" cy="63.4139" r="0.982285" fill="#657289" />
    <path
      d="M12.7793 63.3518H14.1982C14.7379 63.352 15.2002 63.7379 15.2969 64.2688L16.1553 68.9846C16.291 69.7314 15.9306 70.4806 15.2627 70.8411C14.3292 71.3449 13.2077 71.3579 12.2627 70.8762L12.1592 70.8235C11.4617 70.468 11.058 69.7165 11.1465 68.9387L11.6689 64.343C11.7331 63.7785 12.2112 63.3518 12.7793 63.3518Z"
      fill="#05B6B2"
      stroke="#657289"
      strokeWidth="0.203117"
    />
    <path
      d="M12.7362 70.4791L12.6526 70.4543C12.2693 70.3406 11.9635 70.0503 11.8302 69.6733L11.7753 69.5181"
      stroke="#F2F3F5"
      strokeWidth="0.203117"
    />
    <path
      d="M14.0941 63.7588L14.2961 63.7719C14.5862 63.7908 14.8226 64.0121 14.8607 64.3004L14.8948 64.5596"
      stroke="#F2F3F5"
      strokeWidth="0.203117"
    />
    <rect x="13.4531" y="0.640625" width="0.320312" height="62.1497" fill="#657289" />
    <rect x="17.2969" y="0.640625" width="0.320312" height="45.491" fill="#657289" />
    <circle cx="17.3544" cy="44.9886" r="0.982285" fill="#657289" />
    <path
      d="M16.623 44.9265H18.042C18.5816 44.9267 19.0439 45.3126 19.1406 45.8435L19.999 50.5593C20.1348 51.3061 19.7744 52.0553 19.1064 52.4158C18.173 52.9196 17.0515 52.9326 16.1064 52.4509L16.0029 52.3982C15.3055 52.0427 14.9018 51.2912 14.9902 50.5134L15.5127 45.9177C15.5769 45.3532 16.0549 44.9265 16.623 44.9265Z"
      fill="#8896AE"
      stroke="#657289"
      strokeWidth="0.203117"
    />
    <path
      d="M16.5799 52.0538L16.4963 52.029C16.113 51.9153 15.8073 51.625 15.6739 51.248L15.619 51.0928"
      stroke="#F2F3F5"
      strokeWidth="0.203117"
    />
    <path
      d="M17.9378 45.3335L18.1398 45.3467C18.43 45.3655 18.6664 45.5868 18.7044 45.8751L18.7386 46.1343"
      stroke="#F2F3F5"
      strokeWidth="0.203117"
    />
    <circle cx="21.1971" cy="32.6594" r="0.982285" fill="#657289" />
    <path
      d="M20.4668 32.5973H21.8857C22.4254 32.5975 22.8877 32.9834 22.9844 33.5143L23.8428 38.2301C23.9785 38.9768 23.6181 39.7261 22.9502 40.0865C22.0167 40.5903 20.8952 40.6034 19.9502 40.1217L19.8467 40.069C19.1492 39.7135 18.7455 38.962 18.834 38.1842L19.3564 33.5885C19.4206 33.024 19.8987 32.5973 20.4668 32.5973Z"
      fill="#8896AE"
      stroke="#657289"
      strokeWidth="0.203117"
    />
    <path
      d="M20.4237 39.7247L20.3401 39.6999C19.9568 39.5862 19.651 39.2959 19.5177 38.9189L19.4628 38.7637"
      stroke="#F2F3F5"
      strokeWidth="0.203117"
    />
    <path
      d="M21.7806 33.0043L21.9826 33.0174C22.2728 33.0363 22.5092 33.2576 22.5472 33.5458L22.5814 33.805"
      stroke="#F2F3F5"
      strokeWidth="0.203117"
    />
    <rect x="21.1406" y="0.640625" width="0.320312" height="31.3952" fill="#657289" />
    <circle cx="25.0409" cy="14.0786" r="0.982285" fill="#657289" />
    <path
      d="M24.3105 14.0164H25.7295C26.2691 14.0165 26.7314 14.4024 26.8281 14.9333L27.6865 19.6492C27.8223 20.3959 27.4619 21.1451 26.7939 21.5056C25.8605 22.0094 24.739 22.0225 23.7939 21.5408L23.6904 21.488C22.993 21.1325 22.5893 20.3811 22.6777 19.6033L23.2002 15.0076C23.2644 14.4431 23.7424 14.0164 24.3105 14.0164Z"
      fill="#8896AE"
      stroke="#657289"
      strokeWidth="0.203117"
    />
    <path
      d="M24.2674 21.1438L24.1838 21.119C23.8005 21.0053 23.4948 20.715 23.3614 20.338L23.3065 20.1828"
      stroke="#F2F3F5"
      strokeWidth="0.203117"
    />
    <path
      d="M25.6253 14.4235L25.8273 14.4366C26.1175 14.4555 26.3539 14.6767 26.3919 14.965L26.4261 15.2242"
      stroke="#F2F3F5"
      strokeWidth="0.203117"
    />
    <rect x="24.9844" y="0.640625" width="0.320312" height="12.8144" fill="#657289" />
    <circle cx="28.8846" cy="2.54527" r="0.982285" fill="#657289" />
    <path
      d="M28.1543 2.48352H29.5732C30.1129 2.48368 30.5752 2.86959 30.6719 3.40051L31.5303 8.11633C31.666 8.86308 31.3056 9.61229 30.6377 9.97278C29.7042 10.4766 28.5827 10.4896 27.6377 10.0079L27.5342 9.9552C26.8367 9.59968 26.433 8.84825 26.5215 8.07043L27.0439 3.47473C27.1081 2.91026 27.5862 2.48355 28.1543 2.48352Z"
      fill="#8896AE"
      stroke="#657289"
      strokeWidth="0.203117"
    />
    <path
      d="M28.1112 9.61073L28.0276 9.58593C27.6443 9.47222 27.3385 9.18188 27.2052 8.80491L27.1503 8.64972"
      stroke="#F2F3F5"
      strokeWidth="0.203117"
    />
    <path
      d="M29.4681 2.89055L29.6701 2.90369C29.9603 2.92256 30.1966 3.14383 30.2346 3.43213L30.2688 3.69135"
      stroke="#F2F3F5"
      strokeWidth="0.203117"
    />
    <rect x="28.8281" y="0.640625" width="0.320312" height="1.28125" fill="#657289" />
  </svg>
);
